var QuickNav = function () {

    return {
        init: function () {
            if( jQuery('.quick-nav').length > 0 ) {
                var stretchyNavs = jQuery('.quick-nav');
                stretchyNavs.each(function(){
                    var stretchyNav = jQuery(this),
                        stretchyNavTrigger = stretchyNav.find('.quick-nav-trigger');

                    stretchyNavTrigger.on('click', function(event){
                        event.preventDefault();
                        stretchyNav.toggleClass('nav-is-visible');
                    });
                });

                jQuery(document).on('click', function(event){
                    ( !jQuery(event.target).is('.quick-nav-trigger') && !jQuery(event.target).is('.quick-nav-trigger span') ) && stretchyNavs.removeClass('nav-is-visible');
                });
            }
        }
    };
}();

QuickNav.init(); // init metronic core componets